import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CreateResponseBase } from '@models/base/createResponseBase.model';
import { CasoUsoDto } from '@models/seguridad/casosUso/casoUsoDto.model';
import { CasoUsoFilter } from '@models/seguridad/casosUso/casoUsoFilter.model';
import { CreateCasoUsoRequest } from '@models/seguridad/casosUso/createCasosUsoRequest.model';
import { UpdateCasoUsoRequest } from '@models/seguridad/casosUso/updateCasosUsoRequest.model';

@Injectable({
  providedIn: 'root'
})
export class CasoUsoService {
  private http = inject(HttpClient);

  private apiUrl = `/api/CasoUso`;

  getAll(): Observable<CasoUsoDto[]> {
    return this.http.get<CasoUsoDto[]>(`${this.apiUrl}/GetAll`);
  }

  getAllByFilter(filter: CasoUsoFilter): Observable<CasoUsoDto[]> {
    return this.http.post<CasoUsoDto[]>(`${this.apiUrl}/GetAllByFilter`, filter);
  }

  getById(id: number): Observable<CasoUsoDto> {
    return this.http.get<CasoUsoDto>(`${this.apiUrl}/GetById?id=${id}`);
  }

  create(request: CreateCasoUsoRequest): Observable<CreateResponseBase> {
    return this.http.post<CreateResponseBase>(`${this.apiUrl}/Create`, request);
  }

  update(request: UpdateCasoUsoRequest): Observable<boolean> {
    return this.http.put<boolean>(`${this.apiUrl}/Update`, request);
  }

  delete(id: number): Observable<boolean> {
    return this.http.delete<boolean>(`${this.apiUrl}/Delete?id=${id}`);
  }

  deleteLogic(id: number): Observable<boolean> {
    return this.http.put<boolean>(`${this.apiUrl}/DeleteLogic`, { id });
  }
}
